module.exports = __webpack_public_path__ + "static/media/welcome.dbcfba5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/WelcomePopup/welcome.svg
// module id = 2236
// module chunks = 0